import "./PublicationSearchPageMobileFilters.scss";
import { MinusCircleIcon, PlusCircleIcon } from "/App.Components";
import { ReactNode, useState } from "react";
import { ColorTheme } from "/Models/Models/ColorTheme";
import { DesignTheme } from "/App.GeneratedEnums";
import { createSpreadableBem } from "/Helpers/createBem";

export interface Props {
  heading?: string;
  theme?: DesignTheme;
  children?: ReactNode | ReactNode[];
}

const PublicationSearchPageMobileFilters = (props: Props) => {
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(true);
  const { heading, children, theme } = props;
  const bem = createSpreadableBem(
    "publication-search-page-mobile-filters-norad",
  );
  return (
    <div
      {...bem("", {
        "--theme-insight": props.theme === DesignTheme.Insight,
      })}
    >
      <button
        {...bem("__expander")}
        onClick={() => setMobileFiltersOpen(!mobileFiltersOpen)}
      >
        {heading && <span {...bem("__heading")}>{heading}</span>}
        {mobileFiltersOpen && (
          <MinusCircleIcon
            size="32"
            thickness="Light"
            color={
              theme === DesignTheme.Insight
                ? ColorTheme.insightDarkBlue
                : ColorTheme.iconStrong
            }
          />
        )}
        {!mobileFiltersOpen && (
          <PlusCircleIcon
            size="32"
            thickness="Light"
            color={
              theme === DesignTheme.Insight
                ? ColorTheme.insightDarkBlue
                : ColorTheme.iconStrong
            }
          />
        )}
      </button>
      {mobileFiltersOpen && <div {...bem("__filters")}>{children}</div>}
    </div>
  );
};

export default PublicationSearchPageMobileFilters;
